// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"projects_signup_src_app_public_public_module_ts":"a3c26032aeb18a97","node_modules_ngx-quill_fesm2022_ngx-quill-quill-CUw8Q_m0_mjs":"8eb1f076921bf427","projects_signup_src_app_public_signup_signup_module_ts":"b9141fb761578f1c"}[chunkId] + ".js";
};